import React, {Component} from "react"
import styles from "./Loader.module.css"
import beOnAirLogo from "./img/beon-air-logo-web.png"

interface Props {
    isVisible: boolean
    classNameWrap?: string
}

export class Loader extends Component<Props, {}> {
    public render() {
        const {isVisible, classNameWrap} = this.props
        return (
            <div
                className={`${styles.loadingContainer} ${
                    isVisible ? styles.visible : styles.invisible
                } ${classNameWrap ? classNameWrap : ""}`}>
                <img src={beOnAirLogo} alt="beOnAirLogo" />
                <div className={styles.LoaderBars}>
                    <div className={styles.Bar}></div>
                    <div className={styles.Bar}></div>
                    <div className={styles.Bar}></div>
                </div>
            </div>
        )
    }
}
